export default __webpack_public_path__ + "static/media/new-floor-1.ee1efcb4.svg";